/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OfferCategoryEnum = 'PRIMARY' | 'ADDON' | 'ONETIME' | 'ONDEMAND';

export const OfferCategoryEnum = {

    PRIMARY: 'PRIMARY' as OfferCategoryEnum,

    ADDON: 'ADDON' as OfferCategoryEnum,

    ONETIME: 'ONETIME' as OfferCategoryEnum,

    ONDEMAND: 'ONDEMAND' as OfferCategoryEnum
};

